export default __webpack_public_path__ + "static/media/pkt4.deef9897.svg";